import { SubmitHandler, useForm } from "react-hook-form";
import { ReportPostType } from "../../types/Report";
import Input from "../core/Input";
import { ErrorMessage } from "@hookform/error-message";
import {
  IconAlignBoxLeftTopFilled,
  IconCheck,
  IconError404,
  IconTypography,
} from "@tabler/icons-react";
import { REQUIERED } from "../../const/ValidationHints";
import TextArea from "../core/TextArea";
import {
  TEXT_REPORT_SUBMITTED,
  TEXT_UPLOADING,
  TEXT_UPLOADING_FAILED,
} from "../../const/text";
import { SubmitContext } from "../../context/context.submit";
import { useContext } from "react";
import { AuthContext } from "../../context/context.authentication";
import { LOADING_CIRCLE } from "../core/loading/LoadingCircle.tsx";

const ReportForm = ({
  children,
  onSubmit,
  userId,
  itemId,
  title,
  description,
}: {
  onSubmit: (data: ReportPostType) => Promise<void>;
  children: React.ReactNode;
  userId?: string;
  itemId?: string;
  title?: string;
  description?: string;
}) => {
  const { initSubmit, setButtonElem, setError, finishSubmit } =
    useContext(SubmitContext);
  const { auth } = useContext(AuthContext);
  const reportForm = useForm<ReportPostType>({
    defaultValues: {
      title: title,
      description: description,
      itemId: itemId,
      userId: userId,
      reportedBy: auth.ok ? auth.sub : undefined,
    },
    mode: "all",
  });
  const {
    register,
    handleSubmit,
    formState: { errors, touchedFields },
  } = reportForm;

  const submit: SubmitHandler<ReportPostType> = async (data) => {
    if (!initSubmit()) return;
    setButtonElem(
      <>
        {LOADING_CIRCLE}
        {TEXT_UPLOADING}
      </>,
    );
    await onSubmit(data);
    if (!finishSubmit(true)) {
      setError(TEXT_UPLOADING_FAILED);
      setButtonElem(<IconError404 />);
      return;
    }
    setButtonElem(
      <>
        <IconCheck />
        {TEXT_REPORT_SUBMITTED}
      </>,
    );
  };

  return (
    <form
      onSubmit={handleSubmit(submit)}
      className="flex flex-col gap-2 justify-stretch"
    >
      <Input
        input="input"
        validatorHint={<ErrorMessage errors={errors} name="title" />}
        icon={<IconTypography stroke={2} />}
        label={"Title"}
        isTouched={!!touchedFields.title}
        isError={!!errors.title}
      >
        <input
          type="text"
          placeholder={`Was ist dein Anliegen`}
          minLength={1}
          maxLength={64}
          {...register("title", { required: REQUIERED })}
        />
      </Input>
      <Input
        input="textarea"
        validatorHint={<ErrorMessage errors={errors} name="description" />}
        icon={<IconAlignBoxLeftTopFilled stroke={2} />}
        label="Beschreibung"
        isTouched={!!touchedFields.description}
        isError={!!errors.description}
      >
        <TextArea
          placeholder="Beschreibe dein Anliegen."
          fieldKey={"description"}
          register={register}
          registerOptions={{ required: { value: true, message: REQUIERED } }}
        />
      </Input>

      {children}
    </form>
  );
};
export default ReportForm;
